<omni-loader [background]="true"></omni-loader>
<dcu-notification></dcu-notification>
<div class="app-body">
    <main class="main d-flex align-items-center justify-content-center flex-column">
      <div class="card p-4 card-login">
        <div class="card-body">
            <form [formGroup]="loginForm" (ngSubmit)="onLogin()" (keydown.enter)="onLogin();false" autocomplete="off">
              <div class="position-relative">
                <span class="input-user"></span>
                <input class="form-control" placeholder="Tên đăng nhập" formControlName="userName" [required]="true" autofocus="true" autocomplete="false" id="login-username-id">
              </div>
              <div class="position-relative">
                <span class="input-password"></span>
                <input type="password" class="form-control" placeholder="Mật khẩu" formControlName="password" [required]="true" autocomplete="false" id="login-password-id">
              </div>
              <button type="button" class="btn btn-login-custom px-4 w-100" (click)="onLogin()" id="login-button-id">Đăng nhập</button>
            </form>
        </div>

      </div>
      <div class="text-white" style="font-size: 13px;">
        <span class="info">Copyright © 2021. All Rights Reserved.</span>
      </div>
    </main>
</div>
